if (!customElements.get('more-events')) {
  class MoreEvents extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.resizeObserver = null;
      this.equalizeTitles = this.equalizeTitles.bind(this);
    }

    connectedCallback() {
      this.init();
      this.equalizeTitles();
      window.addEventListener('resize', this.equalizeTitles);
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.equalizeTitles);
        this.resizeObserver.observe(this);
      }
    }

    disconnectedCallback() {
      this.destroy();
      window.removeEventListener('resize', this.equalizeTitles);
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
    }

    get swiperContainer() {
      return this.querySelector('.more-events__swiper');
    }

    get paginationEl() {
      return this.querySelector('.swiper-pagination');
    }

    get prevButtonEl() {
      return this.querySelector('.swiper-button-prev');
    }

    get nextButtonEl() {
      return this.querySelector('.swiper-button-next');
    }

    getConfig() {
      return {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 12,
        centeredSlides: false,
        grabCursor: true,
        keyboard: {
          enabled: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: 12,
          },
        },
        pagination: {
          el: this.paginationEl,
          type: 'fraction',
        },
        navigation: {
          nextEl: this.nextButtonEl,
          prevEl: this.prevButtonEl,
        },
      };
    }

    equalizeTitles() {
      const titles = this.querySelectorAll('.event-card__title');
      if (!titles.length) return;

      titles.forEach((title) => {
        title.style.minHeight = '';
      });

      requestAnimationFrame(() => {
        let max = 0;
        titles.forEach((title) => {
          if (title.offsetHeight > max) max = title.offsetHeight;
        });
        titles.forEach((title) => {
          title.style.minHeight = `${max}px`;
        });
      });
    }

    init() {
      if (this.swiperContainer) {
        this.swiper = new Swiper(this.swiperContainer, this.getConfig());
      }
    }

    destroy() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  }

  customElements.define('more-events', MoreEvents);
}
